<template>
 <el-collapse-transition>
    <div class="container" v-show="!isRemoved">
      <div class="delete-btn" :class="{'is-disabled': disableRemove}" @click="toggleRemoved(true)"></div>
      <div class="pics">
        <div class="pics__big" :class="{'is-vertical': isVertical}">
          <img :src="activeSnap.url || customSnap.url" alt="">
          <div
            class="swap-btn"
            v-if="!activeSnap.url && customSnap.url"
            @click="getCoverFile()"
          >
            替换
          </div>
        </div>
        <div class="pics__select">
          <div class="pics__text">请选择封面</div>
          <div class="pics__small"
            :class="{active: item.active, 'is-vertical': isVertical}"
            v-for="(item, i) in snaps" :key="i"
            @click="selectCustomSnap(false); selectItem(snaps, i)"
          >
            <img :src="item.url" alt="">
          </div>

          <!-- customSnap -->
          <div
            v-if="customSnap.url"
            class="pics__small"
            :class="{active: customSnap.active, 'is-vertical': isVertical}"
            @click="selectItem(snaps, -1); selectCustomSnap(true)"
          >
            <img :src="customSnap.url" alt="">
          </div>
          <div v-show="!customSnap.url" class="pics__add" @click="getCoverFile()">
            <i class="my-icon-add"></i>
            <input ref="fileInputRef" type="file" accept="image/jpg,image/jpeg,image/png,image/gif,.svg" name="files[]" style="display: none;"
              @change="onChangeCoverFile($event)"
            >
          </div>
        </div>
        <div class="pics__bottom-text">
          （如果需要上传封面，建议大小不超过500K）
        </div>
      </div>
      <div class="info">
        <div class="field">
          <div class="field__title is-required">标题</div>
          <div class="field__content">
            <div class="field__input">
              <input type="text" placeholder="" v-model="info.title" maxlength="32">
            </div>
            <div class="field__count">{{info.title.length}}/32</div>
          </div>
        </div>
        <div class="field">
          <div class="field__title">简介</div>
          <div class="field__content">
            <div class="field__textarea">
              <textarea
                v-model="info.desc"
                type="text"
                placeholder="简介可展示关于场景的更多背景信息或内容哦"
                maxlength="64"
              ></textarea>
            </div>
            <div class="field__count">{{info.desc.length}}/64</div>
          </div>
        </div>
        <div class="field">
          <div class="field__title is-required">风格</div>
          <div class="field__content">
            <div class="field__items">
              <div
                class="field__item"
                :class="{active: item.active}"
                v-for="(item, i) in styleArr"
                :key="i"
                @click="selectStyleItem(styleArr, i)"
              >
                {{item.name}}
              </div>
            </div>
          </div>
        </div>
        <div class="field">
          <div class="field__title is-required">分类</div>

          <div class="field__content">
            <div class="field__items">
              <div
                class="field__item"
                :class="{active: item.active}"
                v-for="(item, i) in activeCate"
                :key="i"
                @click="selectCate(item, i, activeCate)"
                :data-id="item.id"
              >
                {{item.name}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
 </el-collapse-transition>
</template>

<script>
import { mapGetters } from 'vuex'
import map from 'lodash/map'
import filter from 'lodash/filter'
import domtoimage from '../../../plugins/dom-to-image';
import setBlobImageSize from '../../../plugins/setBlobImageSize';
import snap from '../../mixins/snap.vue';

export default {
  mixins: [snap],
  props: [
    'scene'
  ],
  data () {
    return {
      isRemoved: false,
      disableRemove: false,
      info: {
        title: '',
        desc: '',
        style: '',
        cate: '',
      },
      styleArr: [],
      cateDict: {},
      activeCate: {},
      snaps: [],
      customSnap: {},
      uploadThumbnail: '',
    }
  },
  computed: {
    ...mapGetters([
      'WorksName',
      'StyleArrayMsg',
      'StyleDataMsg',
      'TOOL'
    ]),
    activeStyle () {
      return this.styleArr.filter((v) => {
        return v.active
      })[0] || this.styleArr[0] || {};
    },
    activeSnap () {
      return (this.snaps.filter((v) => {
        return v.active
      }) || [])[0] || {};
    },
    isVertical () {
      return this.TOOL.optimized === 'Vertical';
    }
  },
  watch: {
    cateDict: {
      handler (val) {

      }
    },
    // 'info.title': {
    //   handler (val) {
    //     if (!val) {
    //       this.info.title = this.WorksName;
    //     }
    //   }
    // }
  },
  created () {
    this.$bus.on('coverDialog.confirm', (coverPic, scene) => {
      if (scene === this.scene) {
        this.customSnap = coverPic;
        this.selectItem(this.snaps, -1);
        this.selectCustomSnap(true);
      }
    });
  },
  mounted () {
    this.info = {
      ...this.info,
      title: this.WorksName
    };

    // this.initStyleItems();
  },
  methods: {
    init () {
      this.toggleDR(false);
      this.toggleRemoved(false);
      this.initStyleItems();
      this.snaps = [];
    },
    initStyleItems () {
      this.styleArr = this.StyleArrayMsg.map((item) => {
        return {
          id: item.id,
          name: item.name,
          active: item.id === this.StyleDataMsg.id
        }
      })
    },
    initCateItems (dict = {}) {
      this.cateDict = dict;
      this.handleCateDictChange(dict);
    },
    handleCateDictChange (dict) {
      let target;
      for (let key in dict || this.cateDict) {
        if (key == this.activeStyle.id) {
          target = this.clone( this.cateDict[key] );
        }
      }
      let isFirst = true;
      map(target, (v) => {
        v.active = isFirst;
        isFirst && (isFirst = false);
      });

      this.activeCate = target;
    },
    clone (obj) {
      return JSON.parse(JSON.stringify(obj));
    },
    toggleRemoved (flag) {
      if (this.disableRemove) {
        return;
      }
      this.isRemoved = flag;
      this.$bus.emit('exportScene.toggleRemoved', flag);
    },
    toggleDR (flag) {
      this.disableRemove = flag;
    },
    selectItem(items, index) {
      map(items, (v, i) => {
        this.$set(v, 'active', index == i)
      })
    },
    selectStyleItem (items, index) {
      this.selectItem(items, index);
      this.$nextTick(() => {
        this.renderCate();
      })
    },
    selectCate (item, i, items) {
      let filtered = filter(items, item => item.active);
      if (filtered[0] === item && filtered.length === 1) {
        return;
      }
      this.$set(item, 'active', !item.active)
    },
    renderCate () {
      let target;
      for (let key in this.cateDict) {
        if (key == this.activeStyle.id) {
          target = this.cateDict[key];
        }
      }
      let isFirst = true;
      map(target, (v) => {
        v.active = isFirst;
        isFirst && (isFirst = false);
      });

      this.activeCate = target;
    },

    // 截取封面相关 start
    getSnaps () {
      const vm = this;
      let scenes = this.TOOL.sprites;
      let cacheScene = this.TOOL.getSelectScenes();
      // let pointObj = vm.getMiddlePoint();
      let jqPlayer = this.TOOL.player.ele
      jqPlayer.show();
      let startDom//= this.TOOL.contentBody[0]
      let myTasks = [];
      myTasks[0] = () => {
        return new Promise((resolve) => {
          let dur = vm.TOOL.sprites[0].getDuration()
          let point = dur > 1000 ? 1000 : 500;
          // 截取第一场第一秒
          let ms = point;
          // eve('playByFrame', null, parse(ms), this.scene.id);
          this.TOOL.eve.emit('play_' + this.scene.id, parse(ms));
          const palyerScene = jqPlayer.find('#player-scene-' + this.scene.id)[0] || scenes[0].element.content[0];
          this.getSnapByDom(
            startDom || palyerScene || scenes[0].element.content[0],
            { sec: ms / 1000, scene: this.scene }
          )
            .then(() => {
              resolve();
            })
        })
      }
      myTasks[1] = () => {
        // this.activatePreview({
        //   url: (this.snaps[0] || {}).url
        // })

        return Promise.resolve()
      }
      myTasks[2] = () => {
        return new Promise((resolve, reject) => {
          let point = this.scene.duration / 2 | 0;
          // eve('playByFrame', null, parse(point), this.scene.id);
          this.TOOL.eve.emit('play_' + this.scene.id, parse(point));
          vm.getSnapByDom(
            startDom || jqPlayer.find('#player-scene-' + this.scene.id)[0],
            { sec: point / 1000, scene: this.scene }
          )
            .then(() => {
              resolve()
            })
            .catch((err) => {
              reject(err)
            })
        })
      }
      myTasks[3] = () => {
        return new Promise((resolve, reject) => {
          let id = this.scene.id;
          let point = this.scene.duration - 1000;
          // eve('playByFrame', null, parse(point), id);
          this.TOOL.eve.emit('play_' + id, parse(point));
          this.getSnapByDom(
            startDom || jqPlayer.find('#player-scene-' + this.scene.id)[0] || scenes[scenes.length - 1].element.content[0],
            { sec: point / 1000, scene: this.scene }
          ).then(() => {
            onOpsEnd();
            resolve();
          })
        })
      }

      let process = () => {
        return myTasks[0]()
          .then(myTasks[1])
          .then(myTasks[2])
          .then(myTasks[3])
          .catch((err) => {
            onOpsEnd();
            console.warn(err)
          })
      }

      // 显示content层的素材
      function showSprites (scene) {
        let {duration, nowTime} = scene;
        let sec = nowTime;
        nowTime *= 1000;
        scene.sprites.forEach((sprite) => {
          sprite.effect._syncContent(parse(nowTime));
        });

        // scene.updateBgVideo(scene.nowTime * scene.editor.option.frameRate)
      }

      // video sprite and video bg
      function syncVideoCurrentTime () {
        vm.TOOL.sprites.forEach((scene) => {
          scene.updateBgVideo(scene.nowTime * scene.editor.option.frameRate);
          (scene.sprites.filter(s => s.type === 'Video') || [])
            .map(v => {
              v.updateCurrentTimeBySec(scene.nowTime);
            })
        })
      }

      function onOpsEnd () {
        // vm.TOOL.selectScenes(cacheScene);

        // 隐藏player层
        vm.TOOL.cancelPlay();
        cacheScene.show();
        showSprites(cacheScene);
        syncVideoCurrentTime();

        vm.$store.commit('save_TopnavMsg', {
          isShowSavingMask: false,
        });
        vm.hidden = false;
      }

      function parse (n) {
        return n / 1000 * 60
      }

      return process();

    },
    async getSnapByDom (dom, { sec, scene } = {}) {
      let myResolve
      dom.style.display = '';
      let $video = $(dom).find('video');
      let imgWrapper;
      let extraShowEl = false;

      if ($video[0]) {
        await this.beforeGetSnap({palyerScene: dom, sec, scene});
      }
      // let isLatestChromeDev
      // if (isLatestChromeDev) {
      //   await this.addBlobs(dom);
      // }

      let domH = dom.offsetHeight;
      let domW = dom.offsetWidth

      domtoimage.toBlob2(dom, {
        bgcolor: 'transparent',
        quality: 0.5,
        style: {
          overflow: 'hidden',
          // transform: `scale(${400 / dom.offsetWidth})`,
          // transformOrigin: '0 0'
        },
        _width: dom.offsetWidth,
        _height: dom.offsetHeight,
        width: 640,
        height: 640 * dom.offsetHeight / dom.offsetWidth,
        filter: node => {
          // let isMask = node && node.classList && node.classList.contains('mask-blur');
          // console.log({node, bool: isMask})

          let notVideo = node.tagName !== 'VIDEO';
          let isImg = node.tagName === 'IMG';
          let isHandWriteSvg = node.classList && node.classList.contains('_my-hand-player-svg');
          if (isHandWriteSvg) {
            extraShowEl = $(node).next().show();
          }
          let hasSpecial = node.classList
            && (node.classList.contains('frame-image') || node.classList.contains('_my-hand-player-svg'));
          if (hasSpecial) {
            return false;
          }
          if (isImg) {
            return node.src && node.src.length > 0;
          } else {
            return notVideo;
          }
        }
      })
        .then(async (blob) => {
          if (extraShowEl.length) {
            extraShowEl.hide();
          }
          if (this.TOOL.optimized !== 'Horizontal') {
            let height = 640 * domH / domW;
            let width = height * 9 / 16;
            setBlobImageSize({
              blob,
              height,
              width,
              sx: (640 - width) / 2,
              sy: 0,
              sw: width,
              sh: height
            })
              .then((blob) => {
                this.snaps.push({
                  blob,
                  url: this.getBlobUrl(blob),
                  active: !this.snaps.length
                })
                dom.style.display = 'none';
                myResolve();
              })

            return;
          }
          this.snaps.push({
            blob,
            url: this.getBlobUrl(blob),
            active: !this.snaps.length
          })
          dom.style.display = 'none';
          myResolve();
        })
        .catch(err => {
          console.warn(err);
          myResolve();
        })
        .finally(() => {
          this.TOOL.sprites.forEach(scene => {
            scene.sprites.forEach(sprite => {
              if (sprite.type === 'Video') {
                const ele = document.getElementById('sprite-' + sprite.id);
                ele.style.backgroundImage = ''
                const playerEle = document.getElementById('player-sprite-' + sprite.id);
                playerEle.style.backgroundImage = ''
              }
            })
          });
        })

      return new Promise((resolve) => {
        myResolve = resolve;
      })
    },
    restoreContentLayer (scene) {
      this.TOOL.cancelPlay();
      if (!scene) {
        return;
      }
      scene.show();
      let { duration, nowTime } = scene
      nowTime *= 1000;
      scene.sprites.forEach((sprite) => {
        sprite.effect._syncContent(parse(nowTime));
      });
      function parse (n) {
        return n / 1000 * 60
      }
    },
    // 截取封面相关 end

    getBlobUrl (blob) {
      return window.URL.createObjectURL(blob || new Blob())
    },

    getSelectedCate () {
      let selected = []
      for (let k in this.activeCate) {
        let v = this.activeCate[k]
        if (v && v.active) {
          selected.push(v.id)
        }
      }

      return selected
    },

    // 提交数据
    async submit (sceneJson) {
      let pic = await this.submitPic();
      let data = JSON.stringify( sceneJson || this.scene.toJson() );
      let selectedCates = this.getSelectedCate();
      if (!selectedCates.length) {
        throw new Error('__导出场景页失败，请选择分类');
      }
      let categories = '' + selectedCates.join(',');
      return this.$http.post('/api/user/scene', {
        designer: 1,
        data,
        title: this.info.title,
        description: this.info.desc,
        categories,
        thumbnailUrl: pic.filename,
        platform: 6,
        duration: this.scene.duration / 1000 | 0,
        payType: 0
      }).then((res) => {
        if (res.data.code !== 200) {
          throw new Error();
        }
      })
    },
    submitPic () {
      let formData = new FormData();
      formData.append("scene_thumbnail", this.activeSnap.blob || this.customSnap.blob);

      return this.$http.post('/api/upload/file', formData)
        .then(res => {
          return res.data.data
        })
    },

    // submit end

    // upload cover
    onChangeCoverFile (ev) {
      let {files} = this.$refs.fileInputRef;
      if (files[0].size > 10 * 1024 * 1024) {
        this.$message({
          type: 'error',
          message: '选中图片已经超出10MB限制'
        });
        this.$refs.fileInputRef.value = '';
        return;
      }
      this.$bus.emit('FeaturesPop_close_vue',{	// 关闭弹窗
        type : 3
      });
      this.uploadThumbnail = window.URL.createObjectURL(files[0]);
      // $('<img>').prop('src', this.uploadThumbnail).prependTo('body')
      this.$bus.emit('coverDialog.initUrl', this.uploadThumbnail, files[0], this.scene);
      this.$nextTick(() => {
        this.$store.commit('save_TopnavMsg', {
          isShowSceneCoverDialog: true,
        });
      })
      // this.$store.commit('save_Cover', {
      //   url: this.uploadThumbnail,
      // });
      this.$refs.fileInputRef.value = '';

      // this.backupCover = this.previewCoverUrl;
    },

    getCoverFile () {
      this.$refs.fileInputRef.click();
    },

    selectCustomSnap (flag = true) {
      this.customSnap = {
        ...this.customSnap,
        active: flag,
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../style/_colors.scss";

.container {
  display: flex;
  justify-content: space-between;
}
.delete-btn {
  width: 40px;
	height: 40px;
	background-color: #f8f8fc;
  background-image: url('../../../../static/svg/delete.svg');
  background-size: 21px 21px;
  background-repeat: no-repeat;
  background-position: center center;
	border-radius: 4px;
	border: solid 1px #ddd9eb;
  cursor: pointer;
}
.pics {
  width: 470px;
  height: 355px;
  margin-left: 20px;

  &__select {
    display: flex;
    margin-top: 30px;
  }

  &__text {
    white-space: nowrap;
  }

  &__big {
    position: relative;
    width: 470px;
    height: 265px;
    border: solid 1px #d8d8e5;
    &.is-vertical {
      width: 265px * 9 / 16;
    }
    & > img {
      height: 100%;
    }
  }

  &__small {
    width: 100px;
    height: 57px;
    margin-left: 8px;
    border: solid 1px #d8d8e5;

    &.is-vertical {
      width: 57px * 9 / 16;
    }

    &.active {
      outline: solid 1.5px #5778fb;
    }

    & > img {
      height: 100%;
    }
  }

  &__add {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 70px;
    height: 50px;
    background-color: #ececf7;
    border-radius: 4px;
    border: solid 1px #d8d8e5;
    margin-left: 6px;
    margin-top: 3.5px;
    cursor: pointer;
  }

  &__bottom-text {
    height: 15px;
    margin-left: -48px;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #c2c2d9;
    margin-top: 13px;
  }
}
.info {
  width: 590px;
  margin-left: 70px;
}

.field {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 23px;

  &__title {
    position: relative;
    &.is-required {
      &:before {
        content: ' ';
        position: absolute;
        right: -0.6em;
        top: -0.2em;
        width: 8px;
        height: 8px;
        border-radius: 8px;
        transform: scale(0.6);
        background-color: red;
      }
    }
  }

  &__content {
    position: relative;
  }

  &__input {
    position: relative;
    width: 527px;
    height: 40px;
    border-radius: 4px;
    background-color: $c9;
    transition-duration: 0.3s;
    >input {
      width: 100%;
      height: 100%;
      padding-left: 1em;
      padding-right: 1em;
      border: none;
      background-color: transparent;
    }
  }

  &__textarea {
    position: relative;
    width: 527px;
    height: 80px;
    border-radius: 4px;
    background-color: $c9;
    >textarea {
      resize: none;
      width: 100%;
      height: 100%;
      border: none;
      background: transparent;
      padding: 1em;
    }
  }

  &__count {
    position: absolute;
    bottom: 0.6em;
    right: 1em;
    color: $c10;
  }

  &__items {
    display: flex;
    width: 527px;
    flex-wrap: wrap;
  }

  &__item {
    min-width: 100px;
    height: 40px;
    padding-left: 1em;
    padding-right: 1em;
    margin-top: 5px;
    margin-bottom: 5px;
    background-color: #f8f8fc;
    border-radius: 4px;
    border: solid 1px #ddd9eb;
    color: #474261;
    margin-right: 6px;
    line-height: 38px;
    text-align: center;

    &:nth-of-type(5n) {
      margin-right: 0;
    }

    &.active {
      border: solid 1px #5778fb;
      color: #5778fb;
    }
  }
}

.is-disabled {
  opacity: .5;
}

.my-icon-add {
  position: relative;
  display: inline-block;
  width: 18px;
  height: 18px;
  color: $c2;
  &:before {
    position: absolute;
    left: 0;
    top: 50%;
    content: ' ';
    height: 2px;
    width: 100%;
    margin-top: -1px;
    background-color: $c2;
  }

  &:after {
    position: absolute;
    top: 0;
    left: 50%;
    content: ' ';
    height: 100%;
    width: 2px;
    margin-left: -1px;
    background-color: $c2;
  }
}

.swap-btn {
      position: absolute;
      right: 10px;
      bottom: 10px;
      width: 60px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background-color: $c0;
      border: 1px solid $c3;
      border-radius: 4px;
      color: $c3;
      box-shadow: 0 0 3px 0 rgba($c3, 0.3);
      cursor: pointer;

      &:hover {
        color: $c2;
        border-color: $c2;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/topnav/exportDialog/exportScene.vue